module.exports = __webpack_public_path__ + "img/list48.a86830f9.jpeg";